import { useUpdatePlanBasePrice, useUpdatePlanPrice } from '@/hooks/usePlanActions';
import type { PhonePlan } from '@octave/contracts';
import { ColumnDef } from '@tanstack/react-table';
import { EditablePriceCell } from './EditablePriceCell';

function BasePriceCell({
  plan,
  organizationId,
}: {
  plan: PhonePlan;
  organizationId: string;
}) {
  const { mutate, isPending } = useUpdatePlanBasePrice(plan.id, organizationId);
  return (
    <EditablePriceCell
      valueCents={plan.price}
      onCommit={(cents) => cents !== null && mutate(cents)}
      isPending={isPending}
    />
  );
}

function CustomPriceCell({
  plan,
  organizationId,
}: {
  plan: PhonePlan;
  organizationId: string;
}) {
  const { mutate, isPending } = useUpdatePlanPrice(plan.id, organizationId);
  return (
    <EditablePriceCell
      valueCents={plan.customPrice}
      onCommit={(cents) => mutate(cents)}
      allowEmpty
      isPending={isPending}
    />
  );
}

interface ColumnsProps {
  organizationId: string;
}

export const createColumns = ({
  organizationId,
}: ColumnsProps): ColumnDef<PhonePlan>[] => [
  {
    accessorKey: 'operator.name',
    header: 'Opérateur',
  },
  {
    accessorKey: 'name',
    header: 'Nom du forfait',
  },
  {
    accessorKey: 'price',
    header: () => (
      <div className="flex flex-col">
        <span>Prix de base</span>
        <span className="text-xs font-normal text-muted-foreground">
          toutes les organisations
        </span>
      </div>
    ),
    cell: ({ row }) => (
      <BasePriceCell plan={row.original} organizationId={organizationId} />
    ),
  },
  {
    accessorKey: 'customPrice',
    header: () => (
      <div className="flex flex-col">
        <span>Prix personnalisé</span>
        <span className="text-xs font-normal text-muted-foreground">
          vide = prix de base
        </span>
      </div>
    ),
    cell: ({ row }) => (
      <CustomPriceCell plan={row.original} organizationId={organizationId} />
    ),
  },
];
